<template>
<section>
  <v-data-table
    :headers="headers"
    :items="allOrders"
    class="px-5 table-orders"
    :page="paginationAllOrders.page"
    :items-per-page="paginationAllOrders.page_size"
    :loading="loading.load"
    loading-text="Загрузка... Пожалуйста подождите"
    :mobile-breakpoint="300"
    :height="tableHeight"
    fixed-header
    hide-default-footer
    @update:options="updatePagination"
  >
    <template v-slot:item.user_last_name="{ item }">
      <span
        class="text-decoration-underline cursor-pointer text-primary"
        @click="openDetailOrderModal(item)"
      >
        {{item.user_last_name}} {{item.user_first_name}}
      </span>
    </template>
    <template v-slot:item.status_display="{ item }">
      <div :class="['order-status',item.status]">
        {{item.status_display}}
      </div>
    </template>
    <template v-slot:item.user_phone="{ item }">
      <div>
        {{item.user_phone || '-'}}
      </div>
    </template>
    <template v-slot:item.user_telegram="{ item }">
      <div>
        {{item.user_telegram || '-'}}
      </div>
    </template>
    <template v-slot:item.company_name="{ item }">
      <div>
        {{item.company_name || '-'}}
      </div>
    </template>

    <template v-slot:item.created_at="{ item }">
      <div>
        {{formatDate(item.created_at) || '-'}}
      </div>
    </template>

    <template v-slot:no-data>
      Покупок пользователей не найдено.
    </template>
    <template v-slot:footer>
      <v-data-footer
        :pagination="tablePagination"
        :options="tableOptions"
        items-per-page-text="Покупок на странице:"
        :items-per-page-options="[10, 20, 50, 100, 500, 1000]"
        :page-text="`Всего покупок: ${tablePagination.itemsLength}. Страница ${tablePagination.page} из ${tablePagination.pageCount}`"
        show-current-page
        show-first-last-page
        @update:options="updatePagination"
      />
    </template>
  </v-data-table>
  <ModalDetailOrder
    :show="showDetailModal"
    :detailOrder="detailOrderData"
    @close="closeDetailOrderModal"
  />
</section>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalDetailOrder from '@/components/admin-panel/Modal/ModalDetailOrder.vue';
import { formatDate } from '@/common/util';

/**
 * Компонент: TableOrders
 * Описание:
 */
export default {
  name: 'TableOrders',

  components: { ModalDetailOrder },

  props: {},

  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          width: '80px',
        },
        {
          text: 'Дата заказа',
          align: 'start',
          value: 'created_at',
          width: '170px',
        },
        {
          text: 'Фамилия и имя',
          align: 'start',
          value: 'user_last_name',
          width: '240px',
          sortable: true,
        },
        {
          text: 'Номер телефона',
          value: 'user_phone',
          width: '166px',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Имя в Telegram',
          value: 'user_telegram',
          width: '166px',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Сумма заказа',
          align: 'start',
          value: 'total_amount',
          width: '240px',
        },
        {
          text: 'Статус заказа',
          value: 'status_display',
          width: '204px',
          sortable: false,
        },
        {
          text: 'Название компании',
          value: 'company_name',
          width: '166px',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Электронная почта',
          align: 'start',
          value: 'user_email',
          width: '240px',
        },

      ],
      tableHeight: 500,
      detailOrderData: {},
      showDetailModal: false,
    };
  },

  computed: {
    allowedTests() {
      return [
        { value: '', text: 'Все' },
      ];
    },
    ...mapGetters({
      loading: 'services/services/GET_LOADING_SERVICES',
      allOrders: 'basket/basket/allOrders',
      filters: 'basket/basket/filters',
      pagination: 'basket/basket/pagination',
    }),
    paginationAllOrders() {
      return this.pagination('allOrders');
    },
    tableOptions() {
      return {
        page: this.paginationAllOrders.page,
        itemsPerPage: this.paginationAllOrders.page_size,
      };
    },
    tablePagination() {
      return {
        page: this.paginationAllOrders.page,
        itemsPerPage: this.paginationAllOrders.page_size,
        pageCount: this.paginationAllOrders.totalPage,
        itemsLength: this.paginationAllOrders.count,
      };
    },
  },

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    formatDate,
    ...mapActions({
      setPagination: 'basket/basket/setPaginationOrders',
      detailOrder: 'basket/basket/fetchDetailOrder',
    }),

    async updatePagination(data) {
      if (data.itemsPerPage !== this.paginationAllOrders.page_size || data.page !== this.paginationAllOrders.page) {
        const payload = {
          ...this.paginationAllOrders,
          page: data.page,
          page_size: data.itemsPerPage
        };
        await this.setPagination(payload);
      }
    },
    async openDetailOrderModal(item) {
      this.showDetailModal = true;
      this.detailOrderData = item;
      const res = await this.detailOrder(item);
      if (res && res.id) {
        this.detailOrderData = { ...item, data: res };
      } else {
        this.detailOrderData = null;
        this.showDetailModal = false;
      }
    },
    closeDetailOrderModal() {
      this.detailOrderData = {};
      this.showDetailModal = false;
    }
  },
};
</script>

<style scoped lang="scss">
.table-orders {
  /* Стили компонента */
}
</style>
